module.exports = __webpack_public_path__ + "it.svg?15a1f288182170a580964fb8a64248d7";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/it.svg
// module id = 1429
// module chunks = 0